import { Injectable, NgZone, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_IMAGE, EnitityType,  StringType } from '../core/constant/constant';
import { environment } from 'src/environments/environment';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ToastService } from '../data/services/toastr.service';

@Injectable({
  providedIn: 'root',
})
export class Helper {
  public cuurentLang = localStorage.getItem("theme_lang") ?? environment.defaultLang;
  public defaultLang = environment.defaultLang;

  public jwt_token: any = localStorage.getItem('token');
  is_side_bar: boolean = true;
  uploadFile = ['image/jpeg', 'image/jpg', 'image/png'];
  public admin_details = new BehaviorSubject<any>(null);
  loggedin_admin = this.admin_details.asObservable();
  adminSettings:any = null;
  is_loading: boolean = false;
  public phoneMinLength: number = 8;
  public phoneMaxLength: number = 12;
  public maxPriceLength: number = 10;
  public maxTextLength: number = 50;
  public userToken: any;
  public userLoginToken: any;
  public isMainAdmin = true;
  public getLoginToken = new BehaviorSubject<any>(null);
  public loginToken$ = this.getLoginToken.asObservable();
  public loginToken: any;
  public adminDetails: any;
  public userDetails: any;
  public StringType = StringType;
  public EnitityType = EnitityType;
  public Permissions = Permissions;
  public permissions: any[] = [];
  public showBtnLoader: boolean[] = [];

  currency = '₹';
  countryPhoneCode: string = '+91';
  emailValidationRegex= '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  password_length= 6;
  phone_min_length= 8;
  phone_max_length= 10;
  selectedCategory: any = null;
  
  public uploadedImagesRemoveSubject = new BehaviorSubject<any>(null);
  public removeUploadedImages$ = this.uploadedImagesRemoveSubject.asObservable();
  public imageUrl = environment.IMAGE_URL;
  public apiUrl = environment.API_URL;
  DEFAULT_LOGO = DEFAULT_IMAGE.DEFAULT_LOGO

  constructor(
    public _route: Router,
    public toast: ToastService,
    public trans: TranslateService,
  ) {
    if (localStorage.getItem("userToken")) {
      this.userToken = localStorage.getItem("userToken");
    }

    this.loginToken$.subscribe((token) => {
      if (token) {
        this.loginToken = token;
      }
    });
  }

  handleProductImageError(event: any): void {
    event.target.onerror = null;
    event.target.src = DEFAULT_IMAGE.DEFAULT_LOGO;
  }

  getImageSrc(imagePath?: string | null, fallback: string = this.DEFAULT_LOGO): string {
    if (!imagePath) {
      return fallback;
    }

    if (imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('data:') || imagePath.startsWith('assets/') || imagePath.startsWith('..')) {
      return imagePath;
    }

    return `${this.imageUrl}${imagePath}`;
  }

  phone_number_validation(evt: any) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (
      (charCode > 31 && (charCode < 48 || charCode > 57)) ||
      charCode === 101
    ) {
      return false;
    }
    return true;
  }

  specialAndSpaceValidation(evt: any): boolean {
    const specialCharRegex = /^[^a-zA-Z0-9]$/;

    if (evt.target.value.length < 1 && (evt.code === "Space" || specialCharRegex.test(evt.key))) {
      evt.preventDefault();
      return false;
    }
    return true;
  }


  hasPermission(type: any, staticName: any = null): boolean {
    if (!this.isMainAdmin) {
      let name = this._route.url.split("/").pop();
      if (staticName) {
        name = staticName;
      }
      const index = this.permissions.findIndex((x) => x.name === name);
      if (index !== -1) {
        const permission = this.permissions[index].permission.split("");
        if (permission[Number(type)] === "1") {
          return true;
        }
        return permission[Number(type)] === "1";
      }
      return false;
    }
    return true;
  }

  spaceValidation(evt: any): boolean {
    return !(evt.code === "Space" && evt.target.value.length < 1);
  }

  phoneValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value ? control.value.toString() : "";
      const errors: any = {};
      if (value.length < min) {
        errors["minlength"] = { requiredLength: min, actualLength: value.length };
      }
      if (value.length > max) {
        errors["maxlength"] = { requiredLength: max, actualLength: value.length };
      }
      return Object.keys(errors).length ? errors : null;
    };
  }

  // Prevents non-numeric characters and decimal points
  phonenumer(event: KeyboardEvent) {
    // Only allow numbers and prevent decimal points or any non-numeric input
    const key = event.key;
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault(); // Prevent invalid key press
    }
  }

  pointNotAllow(evt: any): boolean {
    return evt.key !== ".";
  }

  getDiscountedPrice(price: number, discount: number): number {
		if (discount > 0) {
		  return price - (price * discount) / 100;
		}
		return price;
	  }
}
